<template>
  <base-message :full-width="true"
                :message="message"
                :is-active="status === 'start'"
                :fullscreen="fullscreen">
    <div class="message-body is-block quick-select">
      <div class="message-header">
        <label><b class="is-text-rsmall is-text-white">限时选择题：{{ this.message.data.choices.length }} 道</b></label>
      </div>
      <div class="message-block-content">

        <div class="media is-vcenter">
          <div class="media-left">
            <count-down
                :limit="message.data.limit || 10"
                :ref="'count-down-' + _uid"
                @done="checkAnswer"
                @start.once="status = 'start'"></count-down>
          </div>
          <div class="media-content">
            <p>请快速选择正确答案<span v-if="status === 'init'">，准备好开始后，请点击下方按钮</span></p>
            <div v-if="status === 'init'">
              <div class="buttons">
                <button class="button is-small"
                        @click="start"><b>开始</b></button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="teammates.length && status !== 'init'" class="choices">
          <div v-for="(choice, index) in problems"
               class="choice">
            <choice :problem="choice"
                    :id="index"
                    :select="teammates[0].answer[index]"
                    :showAnswer="status === 'done'"
                    @select="select"
                    :teammates="teammates"></choice>
          </div>
        </div>
        <div v-if="status === 'done'" class="result">
          <table class="table is-striped is-bordered is-fullwidth has-text-centered">
            <thead>
            <tr>
              <td class="has-text-centered"></td>
              <td v-for="user in teammates" class="has-text-centered">
                <img class="head-image" :src="$imagePath(user.head_image)" alt="">
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="has-text-centered"><b>答对</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.correct }}</td>
            </tr>
            <tr>
              <td class="has-text-centered"><b>得分</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.score }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="status === 'start'"
             class="buttons"
             @click="checkAnswer(50)">
          <button class="button is-link is-small">抢先交卷</button>
        </div>
      </div>
    </div>
  </base-message>
</template>

<script>
// import LoadingDot from './LoadingDot'
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import CountDown from '@/components/classroom/messages/partials/CountDown'
import Choice from '@/common/problem/Choice'

export default {
  components: { BaseMessage, CountDown, Choice },
  props: ['message'],
  data () {
    return {
      fullscreen: false,
      status: 'init',
      teammates: []
    }
  },
  computed: {
    problems () {
      return IClassroom.problems.filter(p => this.message.data.choices.indexOf(p._id) >= 0)
    }
  },
  mounted () {
    this.addTeamMates(IClassroom.classmates[0], true)
    this.addTeamMates(IClassroom.classmates[1])
    IClassroom.saySomething('请快速选择正确答案，你只有' + (this.message.data.limit || 10) + '秒时间完成作答')
  },
  methods: {
    addTeamMates (userCommit, clear) {
      this.teammates.push({
        head_image: userCommit.head_image,
        answer: this.problems.map(p => {
          if (clear) return ''
          if (userCommit.problems && userCommit.problems[p._id]) return parseInt(userCommit.problems[p._id].answer)
          return ''
        }),
        wrong: 0,
        correct: 0,
        score: 0,
        timeUse: 0
      })
    },
    start () {
      this.$refs['count-down-' + this._uid].start()
      this.startAt = Date.now()
      setTimeout(() => {
        this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    },
    async checkAnswer (bonus = 0) {
      this.$refs['count-down-' + this._uid].pause()
      if (this.status === 'done') {
        return
      }
      const log = IClassroom.createLog(this.message)
      log.data.actions = this.teammates[0].logs
      this.status = 'done'

      await this.$api.put(`/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/problems/answers`, {
        answers: JSON.stringify(this.problems.map((problem, index) => {
          return {
            '_id': problem._id,
            'answer': this.teammates[0].answer[index].toString()
          }
        }))
      })

      this.teammates.forEach(user => {
        user.answer.forEach((answer, index) => {
          if (answer === parseInt(this.problems[index].answer)) {
            user.correct += 1
            user.score += 1
          }
        })
      })

      const correct = this.teammates[0].score === this.problems.length
      IClassroom.addScore(this.teammates[0].score * 10 + (this.teammates[0].score === this.problems.length ? bonus : 0), false)
      IClassroom.showUserBubble(0, correct ? 'check' : 'close', false, 8000)
      IClassroom.playSound(correct ? 'correct' : 'wrong')

      for (let i = 1; i < IClassroom.classmates.length; i++) {
        const user = IClassroom.classmates[i]
        if (user.problems) {
          const userScore = this.problems.reduce((sum, p) => {
            if (user.problems[p._id] && user.problems[p._id].score === 10) {
              return sum + 1
            }
            return sum
          }, 0)
          IClassroom.addScore(userScore * 10, user.isOpponent)
          IClassroom.showUserBubble(i, userScore === this.problems.length ? 'check' : 'close', false, 8000)
        }
        await new Promise((resolve => {
          setTimeout(resolve, 30)
        }))
      }

      await IClassroom.requestNextMessage(6000)
    },
    select (index, option) {
      if (this.status !== 'start') return
      this.$set(this.teammates[0].answer, index, option)
    }
  }
}
</script>

<style lang="stylus" scoped>
.buttons {
  margin-top .5rem
}

.choice:not(:last-child) {
  border-bottom 1px solid #dddddd
}

.choices {
  padding .5rem 1rem
}
</style>
